import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=479f54ac"
import script from "./Draggable.ts?vue&type=script&lang=js&external"
export * from "./Draggable.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports